import axios from 'axios'
import store from '@/store'
import { CRM_API_URL } from '@/constants/api'

function fetchClientsStat (data) {
    const source = axios.CancelToken.source()
    const url = `${CRM_API_URL}/statistic/clients`
    store.dispatch('requests/addUniqueRequest', { url, source })

    return axios.post(url, data, { cancelToken: source.token }).then(response => response.data)
}

function exportClientsStat (data) {
    const source = axios.CancelToken.source()
    const url = `${CRM_API_URL}/statistic/clients/export`
    store.dispatch('requests/addUniqueRequest', { url, source })

    return axios.post(url, data, { responseType: 'blob', cancelToken: source.token })
}

function fetchClientsSegmentationStat (params) {
    const source = axios.CancelToken.source()
    const url = `${CRM_API_URL}/statistic/clients/segmentation`
    store.dispatch('requests/addUniqueRequest', { url, source })

    return axios.post(url, { params, cancelToken: source.token }).then(response => response.data)
}

export default {
    fetchClientsStat,
    exportClientsStat,
    fetchClientsSegmentationStat,
}
